import * as React from 'react'
import { Link } from "react-router-dom"
export default function BlogSidebar(){
    return(
        <div className="news-right-widget">
        <div className="widget widget-author mb-40">
            <div className="widget-title-box pb-25 mb-30">
                <h4 className="widget-sub-title2 fs-20">About Me</h4>
            </div>
            <div className="widget-author-content text-center">
                <img src="assets/img/blog/blog-author1.jpg" alt="Img" />
                <h5>Rosalina D. Willaimson</h5>
                <p>Lorem ipsum dolor sit amet, consect etur adipisicing elit, sed do eiusmod tempor
                    incididunt ut labore.</p>
                <div className="author__social mt-15 mb-1">
                    <Link to="#"><i className="fab fa-facebook-f"></i></Link>
                    <Link to="#"><i className="fab fa-twitter"></i></Link>
                    <Link to="#"><i className="fab fa-behance"></i></Link>
                    <Link to="#"><i className="fab fa-linkedin-in"></i></Link>
                    <Link to="#"><i className="fab fa-google-plus-g"></i></Link>
                </div>
            </div>
        </div>
        <div className="widget widget-search mb-40">
            <div className="widget-title-box pb-25 mb-30">
                <h4 className="widget-sub-title2 fs-20">Search Here</h4>
            </div>
            <form className="subscribe-form mb-10" action="#">
                <input type="text" placeholder="Search your keyword..." />
                <button className="widget-btn"><i className="fal fa-search"></i></button>
            </form>
        </div>
        <div className="widget widget-post mb-40">
            <div className="widget-title-box pb-25 mb-30">
                <h4 className="widget-sub-title2 fs-20">Popular Feeds</h4>
            </div>
            <ul className="post-list">
                <li>
                    <div className="blog-post mb-30">
                        <Link to="/news-details"><img src="assets/img/blog/post-1.jpg"
                                alt="Post Img" /></Link>
                        <div className="post-content">
                            <h6 className="mb-10"><Link to="/news-details">Having education in
                                    an area helps</Link></h6>
                            <span className="fs-14"><i className="fal fa-calendar-alt"></i> 24th March
                                2022</span>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="blog-post mb-30">
                        <Link to="/news-details"><img src="assets/img/blog/post-2.jpg"
                                alt="Post Img" /></Link>
                        <div className="post-content">
                            <h6 className="mb-10"><Link to="/news-details">people think, feel, &
                                    behave in a way</Link></h6>
                            <span className="fs-14"><i className="fal fa-calendar-alt"></i> 24th March
                                2022</span>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="blog-post mb-30">
                        <Link to="/news-details"><img src="assets/img/blog/post-3.jpg"
                                alt="Post Img" /></Link>
                        <div className="post-content">
                            <h6 className="mb-10"><Link to="/news-details">that contributes to
                                    their success</Link></h6>
                            <span className="fs-14"><i className="fal fa-calendar-alt"></i> 24th March
                                2022</span>
                        </div>
                    </div>
                </li>
                <li>
                    <div className="blog-post">
                        <Link to="/news-details"><img src="assets/img/blog/post-4.jpg"
                                alt="Post Img" /></Link>
                        <div className="post-content">
                            <h6 className="mb-10"><Link to="/news-details">improves not only
                                    their personal</Link></h6>
                            <span className="fs-14"><i className="fal fa-calendar-alt"></i> 24th March
                                2022</span>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div className="widget widget-categories-list mb-40">
            <div className="widget-title-box pb-25 mb-30">
                <h4 className="widget-sub-title2 fs-20">Categories</h4>
            </div>
            <ul className="list-none">
                <li><Link to="#">Business <span className="f-right">26</span></Link></li>
                <li><Link to="#">Consultant <span className="f-right">30</span></Link></li>
                <li><Link to="#">Creative <span className="f-right">71</span></Link></li>
                <li><Link to="#">UI/UX <span className="f-right">56</span></Link></li>
                <li><Link to="#">Technologys <span className="f-right">60</span></Link></li>
            </ul>
        </div>
        <div className="widget widget-categories-tag mb-40">
            <div className="widget-title-box pb-25 mb-25">
                <h4 className="widget-sub-title2 fs-20">Instagram Feeds</h4>
            </div>
            <div className="tag-list">
                <Link to="#">Popular</Link>
                <Link to="#">Design</Link>
                <Link to="#">UX</Link>
                <Link to="#">Usability</Link>
                <Link to="#">Develop</Link>
                <Link to="#">Icon</Link>
                <Link to="#">Business</Link>
                <Link to="#">Consult</Link>
                <Link to="#">Kit</Link>
                <Link to="#">Keyboard</Link>
                <Link to="#">Mouse</Link>
                <Link to="#">Tech</Link>
            </div>
        </div>
        <div className="widget widget-add mb-30">
            <h4 className="widget-sub-title2 fs-20 mb-30">Sponsor Adds</h4>
            <div className="banner-content mb-10">
                <img src="assets/img/blog/banner-1.jpg" alt="banner" />
            </div>
        </div>
    </div>
    )
}